import script from "./batchGoodsRemoveRecover.vue?vue&type=script&setup=true&lang=js"
export * from "./batchGoodsRemoveRecover.vue?vue&type=script&setup=true&lang=js"

import "./batchGoodsRemoveRecover.vue?vue&type=style&index=0&id=633f77a4&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633f77a4"]])

export default __exports__